/* eslint-disable */
import storageLocal from '@/api/storage/local';

export default {
    logout() {
        storageLocal.setOtherUserDetails(null);
        storageLocal.setUser(null);
        storageLocal.setAppIds(null);
        storageLocal.setAppTitles(null);
        storageLocal.removePopUp();
        storageLocal.setAdminAppTitles(null);
        storageLocal.setArea(null);
        storageLocal.setRegion(null);
        storageLocal.setInch(null);
        storageLocal.setRelease(null);
        storageLocal.setRegionList(null);
        storageLocal.setAreaRegionList(null);
        storageLocal.setAreaList(null);
        storageLocal.setState(null);
        return;
    },
};
